import apis from '@/apis/coreIAM/apis'
import { apisTypes } from '@/store/mutationTypes'

export default {
    state: {
        retrieveCredentials: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [apisTypes.RETRIEVE_CREDENTIALS_REQUEST]: function (state) {
            state.retrieveCredentials.pending = true;
        },
        [apisTypes.RETRIEVE_CREDENTIALS_SUCCESS]: function (state) {
            state.retrieveCredentials.error = null;
            state.retrieveCredentials.pending = false;
        },
        [apisTypes.RETRIEVE_CREDENTIALS_FAILURE]: function (state, error) {
            state.retrieveCredentials.error = error;
            state.retrieveCredentials.pending = false;
        },
    },
    actions: {
        async retrieveCredentials({ commit }, payload) {
            commit(apisTypes.RETRIEVE_CREDENTIALS_REQUEST)
            return new Promise((resolve, reject) => {
                apis
                    .getApiSecret(payload.uuid)
                    .then((secret) => {
                        commit(apisTypes.RETRIEVE_CREDENTIALS_SUCCESS)
                        resolve(secret.data)
                    })
                    .catch((error) => {
                        commit(apisTypes.RETRIEVE_CREDENTIALS_FAILURE, error)
                        reject(error)
                    })
            })
        },
    }
}